import isEmpty from 'lodash-es/isEmpty'
import { Site } from '../../../common/constants/siteList'
import { getConfigBySite } from '../../../config/sites'
import { ILocationParams } from '../../reducers/reactRouterLocation'

const getDefaultSortParam = (
  params: ILocationParams,
  currentSite: Site | 'defaults' = 'defaults'
) => {
  return isEmpty(params.term)
    ? getConfigBySite(currentSite, 'search_query.default_sort_by')
    : 'relevance'
}

export default getDefaultSortParam
